export const RESIZE_DEBOUNCE_DELAY = 200;
